/* eslint-disable react/no-array-index-key */
import { type OtcWarningModel } from 'autogen/swagger/all';
import OTCNotification from 'components/product/components/OTCNotification';
import React from 'react';

export default function BasketWarnings({ model: warnings }: { model: OtcWarningModel[] }) {
    return (
        <>
            {warnings.map((warning, index) => (
                <OTCNotification key={index} model={warning} />
            ))}
        </>
    );
}
